import { render, staticRenderFns } from "./time-range-defaultValue-editor.vue?vue&type=template&id=aea25968&scoped=true"
import script from "./time-range-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./time-range-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea25968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea25968')) {
      api.createRecord('aea25968', component.options)
    } else {
      api.reload('aea25968', component.options)
    }
    module.hot.accept("./time-range-defaultValue-editor.vue?vue&type=template&id=aea25968&scoped=true", function () {
      api.rerender('aea25968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-time-range/time-range-defaultValue-editor.vue"
export default component.exports